export default __webpack_public_path__ + "static/media/background-present.eaa6c341.png";